import React from 'react'
import { getInclusionIcon } from 'lib/offer/getInclusionIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import { convertMarkdownInclusionsToArray } from 'lib/string/markdownUtils'
import AccommodationPackageInclusionsList from 'components/OfferPage/Accommodation/AccommodationPackageInclusionsList'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LuxuryPlusInclusions from 'loyalty/components/LuxuryPlusInclusions'
import InclusionItem from 'components/Common/InclusionItem'
import { EmptyArray } from 'lib/array/arrayUtils'

interface Props {
  bonusInclusions: Array<App.PackageInclusion>;
  inclusions: Array<App.PackageInclusion>;
  loyaltyInclusions?: Array<App.PackageInclusion>;
  flightInclusion?: App.Inclusion;
  offer?: App.Offer;
}

function RenderInclusions(props: Props) {
  const {
    bonusInclusions,
    inclusions,
    loyaltyInclusions = EmptyArray,
    flightInclusion,
    offer,
  } = props

  const allInclusions = inclusions.filter(inclusion => !inclusion.hasTactical)
  const hasInclusions = allInclusions.length > 0
  const hasInclusionsV2 = allInclusions.some(i => i.descriptionV2List)
  const hasBonusInclusions = bonusInclusions.length > 0
  const hasTacticalInclusions = bonusInclusions.filter(inclusion => inclusion.hasTactical).length > 0

  // bonus inclusions are pre-mapped to descriptionV2
  const hasBonusInclusionsV2 = bonusInclusions.some(i => i.descriptionV2List)

  const hasLoyaltyInclusions = loyaltyInclusions.length > 0

  const hasAnyInclusions = hasInclusions || hasBonusInclusions || hasInclusionsV2 || hasBonusInclusionsV2 || hasLoyaltyInclusions || flightInclusion

  if (!hasAnyInclusions) return null

  return (
    <VerticalSpacer gap={12}>
      {hasLoyaltyInclusions && <LuxuryPlusInclusions loyaltyInclusions={loyaltyInclusions} accommodationOffer={offer} />}
      {(hasBonusInclusions || hasBonusInclusionsV2) && (
        <AccommodationPackageInclusionsList title="bonus">
          {bonusInclusions.map((bonusInclusion, topIndex) => {
            if (bonusInclusion?.descriptionV2List?.length) {
              return bonusInclusion.descriptionV2List.map((inclusionV2, index) => {
                const InclusionIcon = getInclusionIcon(inclusionV2.icon || '')
                return (
                  <BodyTextBlock
                    variant="medium"
                    weight={inclusionV2.isHighlighted ? 'bold' : 'normal'}
                    startIcon={<InclusionIcon colour={inclusionV2.isHighlighted ? 'secondary-normal' : undefined}/>}
                    key={`${topIndex}-${index}`}
                  >
                    {inclusionV2.text}
                  </BodyTextBlock>
                )
              })
            } else {
              const InclusionIcon = getInclusionIcon(bonusInclusion.categoryIcon || '')
              const description = bonusInclusion?.description?.startsWith('-') ?
                bonusInclusion?.description?.slice(1).trim() :
                bonusInclusion.description

              const descriptionLines = description ? convertMarkdownInclusionsToArray(description) : []

              return (
                <React.Fragment key={topIndex}>
                  {descriptionLines.map((line, index) => (
                    <BodyTextBlock
                      variant="medium"
                      weight={hasTacticalInclusions ? 'bold' : 'normal'}
                      startIcon={<InclusionIcon colour={hasTacticalInclusions ? 'secondary-normal' : undefined}/>}
                      key={`${topIndex}-${index}`}
                    >
                      {line}
                    </BodyTextBlock>
                  ))}
                </React.Fragment>
              )
            }
          })}
        </AccommodationPackageInclusionsList>
      )}
      {hasInclusions && (
        <AccommodationPackageInclusionsList
            title={hasBonusInclusions || hasBonusInclusionsV2 ? 'additional' : undefined}
          >
          {flightInclusion && <InclusionItem inclusion={flightInclusion} isHighlighted />}
          {allInclusions.map((inclusion, topIndex) => {
            if (inclusion?.descriptionV2List?.length) {
              return inclusion.descriptionV2List.map((inclusionV2, index) => {
                const InclusionIcon = getInclusionIcon(inclusionV2.icon || '')
                return (
                  <BodyTextBlock variant="medium"
                    weight={inclusionV2.isHighlighted ? 'bold' : 'normal'}
                    startIcon={<InclusionIcon colour={inclusionV2.isHighlighted ? 'secondary-normal' : undefined}/>}
                    key={`${topIndex}-${index}`}
                  >
                    {inclusionV2.text}
                  </BodyTextBlock>
                )
              })
            } else {
              const InclusionIcon = getInclusionIcon(inclusion.categoryIcon || '')
              const description = inclusion?.description?.startsWith('-') ?
                inclusion?.description?.slice(1).trim() :
                inclusion.description

              const descriptionLines = description ? convertMarkdownInclusionsToArray(description) : []

              return (
                <React.Fragment key={topIndex}>
                  {descriptionLines.map((line, index) => (
                    <BodyTextBlock
                      variant="medium"
                      weight="normal"
                      startIcon={<InclusionIcon />}
                      key={`${topIndex}-${index}`}
                    >
                      {line}
                    </BodyTextBlock>
                  ))}
                </React.Fragment>
              )
            }
          })}
        </AccommodationPackageInclusionsList>
      )}
    </VerticalSpacer>
  )
}

export default RenderInclusions
